import styled from 'styled-components';
import StyledSvgAccordion from '../icon/special/accordion-styled';
import { getColorShade, getSizeBy, getColor } from '../../../src/styled/utils';
import { ListItem } from '../list-item';
import { ListItemContent } from '../list-item-content';
import { Body1Styles, Body2Styles, Subtitle1Styles } from '../typography';
import { ListItemIcon } from '../list-item-icon';
export const LeftSidebar = styled.div `
  width: 285px;
  height: 100%;
  overflow: auto;
  border-right: 1px solid ${getColorShade('onSurface', 'outline')};
  transform: translateZ(0);
`;
export const StyledListItemContent = styled(ListItemContent) `
  justify-content: space-between;
  margin-left: 0;
  color: ${getColorShade('onSurface', 'highEmphasis')};
  ${({ $level2 }) => ($level2 ? Body2Styles : Body1Styles)};

  &&& {
    color: ${({ $selected }) => $selected && getColor('quaternary')};
  }
`;
export const StyledListItem = styled(ListItem) `
  outline: 0;

  & > div {
    padding: ${getSizeBy(2.5)} ${({ $isFlat }) => getSizeBy($isFlat ? 4 : 2)};
  }
`;
export const StyledListItemIcon = styled(ListItemIcon) `
  margin-right: ${getSizeBy(2)};
`;
export const Accordion = styled(StyledSvgAccordion) `
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;
export const Counter = styled.div `
  ${Subtitle1Styles};
  padding: ${getSizeBy(0.5)} ${getSizeBy(1.5)};
  color: ${getColor('onSurface')};
  background-color: ${getColor('onBackground')};
  border-radius: ${getSizeBy(20)};
`;
export const Divider = styled.div `
  height: 1px;
  margin-top: ${getSizeBy(3)};
  margin-bottom: ${getSizeBy(4)};
  background-color: ${getColorShade('onSurface', 'outline')};
`;
